export function ProfileData(data) {
    const { id, name, profilePosts, profileTabs } = data;
    return {
        id,
        name,
        positions: profilePosts.map((post) => post.post_code),
        tabs: profileTabs,
    };
}

export function formatProfileData(data) {
    const { name, positions } = data;

    return {
        name,
        post: positions,
    };
}
